import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import { Strings } from "../../resources/i18n/i18n";
import Calender from "../CustomUIComponents/Calender/Calender";
import { INVOICE_DATE_FORMAT } from "../../constants/appConstants";
import { NumericFormat } from "react-number-format";
import MultipleSelectCheckmarks from "../CustomUIComponents/MultiSelectDropDown/MultipleSelectCheckmarks";
import { ADMIN_FIELDS, CEDULA_FIELDS, LOAN_STEPS, loanApplicationFormInputs, PERSONAL_LOAN_FIELD_OVERRIDES, PHONE_FIELDS } from "../CreateLoan/CreateLoanConstants";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
import Utility from "../../utils/Utility";
import { cedulaValidateAction } from "../CreateLoan/CreateLoanAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import UserModal from "../CustomUIComponents/UserModal/UserModal";
class BasicInformation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            basicInformation: {
                businessType: this.props.basicInfo?.businessType,
                ciCustomerSinceYears: this.props.basicInfo?.ciCustomerSinceYears,
                businessEstablishedSinceYears: this.props.basicInfo?.businessEstablishedSinceYears,
                ColmadoTelephone: this.props.basicInfo?.telephone,
                supplierCreditLimit: this.props.basicInfo?.ciCreditLimit,
                NameOfOwner: this.props.basicInfo?.ownerName,
                IDOfOwner: this.props.basicInfo?.ownerId,
                ownerNumber: this.props.basicInfo?.ownerNumber,
                ownerAddress: this.props.basicInfo?.ownerAddress,
                ownerDateOfBirth: this.props.basicInfo?.ownerDateOfBirth,
                ownerHomeType: this.props.basicInfo?.ownerHomeType,
                homeLocation: this.props.basicInfo?.homeLocation,
                familyMembers: this.props.basicInfo?.familyMembers,
                numberOfVehicles: this.props.basicInfo?.numberOfVehicles,
                bankAccount: this.props.basicInfo?.bankAccount,
                bankDetail: this.props.basicInfo?.bankDetail,
                remittanceDetails: this.props.basicInfo?.remittanceDetails,
                socialMediaAccountDetails: this.props.basicInfo?.socialMediaAccountDetails,
                holder: this.props.basicInfo?.holder,
                adminName: this.props.basicInfo?.adminName,
                adminId: this.props.basicInfo?.adminId,
                adminDateOfBirth: this.props.basicInfo?.adminDateOfBirth,
                adminNumber: this.props.basicInfo?.adminNumber,
                adminSince: this.props.basicInfo?.adminSince,
                adminAddress: this.props.basicInfo?.adminAddress,
                adminSalary: this.props.basicInfo?.adminSalary,
            },
            invalidFormField: [],
            errorFieldArray: [],
            showUserModal: false,
            modalMessage: "",
            errorMessage: this.props.errorMessage
        };

    }
    componentDidMount() {
        const { invalidFormField } = this.props;
        const { basicInformation } = this.state;

        if (Array.isArray(invalidFormField) && invalidFormField.length > 0) {
            const basicInfoField = invalidFormField.find(field => field.ft === LOAN_STEPS.BASIC_INFORMATION);
            const basicInfoInvalidFormField = basicInfoField?.ff || [];

            if (basicInfoInvalidFormField.length > 0) {
                const updatedBasicInformation = { ...basicInformation };
                basicInfoInvalidFormField.forEach(field => {
                    if (field in updatedBasicInformation) {
                        updatedBasicInformation[field] = null;
                    }
                });

                this.setState({
                    basicInformation: updatedBasicInformation,
                    invalidFormField: basicInfoInvalidFormField,
                    errorFieldArray: basicInfoInvalidFormField,
                    errorMessage: Strings("pleaseSelectRequiredFields")
                });
            }
        }
        this.props.scrollToTop();
    }

    handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value === Strings("select") ? "" : event.target.value;
        const type = event.target.type;

        this.setState(prevState => {
            let errorFieldArray = prevState.errorFieldArray?.filter(field => field !== name) || [];
            let invalidFormField = prevState.invalidFormField?.filter(field => field !== name) || [];
            let errorMessage = prevState.errorMessage;
            let updatedErrorFieldArray = [];
            let basicInfo = { ...prevState.basicInformation };

            if (name === "holder") {
                basicInfo = {
                    ...basicInfo,
                    [name]: value,
                    adminDateOfBirth: null,
                    adminName: "",
                    adminId: "",
                    adminNumber: "",
                    adminSince: "",
                    adminAddress: "",
                    adminSalary: "",
                };
                errorFieldArray = errorFieldArray.filter(field =>
                    !ADMIN_FIELDS.includes(field)
                );
                errorMessage = "";
            } else if (name === "socialMediaAccountDetails") {
                basicInfo = {
                    ...basicInfo,
                    [name]: value,
                    socialMediaAccount: value.length !== 0
                };
            } else if (name === "remittanceDetails") {
                const valueArray = Array.isArray(value) ? value : [value];
                basicInfo = {
                    ...basicInfo,
                    [name]: valueArray,
                    receivesRemittances: !!valueArray.length
                };
            } else if (name === "bankdetail") {
                basicInfo = {
                    ...basicInfo,
                    [name]: value,
                    bankAccount: !!value
                };
            } else if (prevState.sectionToEdit === "income") {
                basicInfo = {
                    ...basicInfo,
                    [name]: value,
                    monthlyIncome: null
                };
            } else if (type === "radio") {
                basicInfo = {
                    ...basicInfo,
                    holder: value,
                };
            } else {
                basicInfo = {
                    ...basicInfo,
                    [name]: value
                };
            }
            updatedErrorFieldArray = [...errorFieldArray, ...invalidFormField];
            if (updatedErrorFieldArray.length === 0) {
                errorMessage = "";
            }

            return {
                basicInformation: basicInfo,
                errorFieldArray: updatedErrorFieldArray,
                invalidFormField: invalidFormField,
                errorMessage
            };
        });
    };
    handleDOBChange = (value, name) => {
        this.setState(prevState => {
            const basicInformation = {
                ...prevState.basicInformation,
                [name]: Utility.convertDateIntoMiliSeconds(value)
            };
            return {
                errorFieldArray: prevState.errorFieldArray?.filter(field => field !== name) || [],
                basicInformation
            };
        });
    };
    renderDate = (prop, section) => {
        let errorClass = this.state?.errorFieldArray?.includes(prop.key) ? " error-data" : ""

        return (
            <Calender
                handleChange={(event) => { this.handleDOBChange(event, prop.name) }}
                value={this.state.basicInformation[prop.name] || null}
                dateFormat={INVOICE_DATE_FORMAT}
                isBefore={prop.isBefore}
                isAfter={prop.isAfter}
                errorClass={errorClass}
                isValidBirthDate={prop.validateBirthdate}
                disabled={this.props.disableTextField}
            />
        );
    };
    renderSelectionDropDown = (prop, section) => {
        let errorClass = this.state.errorFieldArray?.includes(prop.key) ? " error-data" : "";
        const matchedDropdown = this.props.dropdownValues?.find(item => item.nm === prop.key);
        let dropDownList = matchedDropdown?.opt || [];

        if (prop.key === "ownerHomeType") {
            dropDownList = dropDownList.map((item) => {
                if (typeof item === "string") {
                    return item.toUpperCase()
                }
                return item;
            });
        }
        if (prop.key === "holder") {
            dropDownList = dropDownList.map((item) => {
                if (typeof item === "string") {
                    return item.toUpperCase()
                }
                return item;
            });
        }

        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <TextFieldComponent
                    title=""
                    id={prop.name}
                    type={prop.type}
                    className="noMargin"
                    placeholder={prop.title}
                    handleChange={this.handleChange}
                    value={this.state.basicInformation[prop.name] || ""}
                    multiple={false}
                    halfWidth={false}
                    disabled={prop.disabled || this.props.disableTextField}
                    name={prop.name}
                >
                    {prop.isSelection && (
                        <>
                            <option value="">{Strings("select")}</option>
                            {dropDownList.map((version) => (
                                <option
                                    key={
                                        version.value ||
                                        version.label ||
                                        version.name ||
                                        version.key ||
                                        version.pstid ||
                                        version
                                    }
                                    value={
                                        version.value ||
                                        version.label ||
                                        version.id ||
                                        version.pstid ||
                                        version.name ||
                                        version
                                    }
                                    disabled={
                                        this.props.ZONE_POSITION &&
                                        version.pstid === prop.value
                                    }
                                >
                                    {version.label ||
                                        version.name ||
                                        version.pstn ||
                                        Strings(version)}
                                </option>
                            ))}
                        </>
                    )}
                </TextFieldComponent>
            </div>
        );
    };

    renderNumberTextFields = (prop, section) => {

        let errorClass = this.state.errorFieldArray?.includes(prop.name) ? " error-data" : ""
        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <NumericFormat
                    name={prop.name}
                    className={"form-control w-100"}
                    onValueChange={(event) => {
                        const target = {
                            name: prop.name,
                            value: event.value ? event.value : "",
                        };
                        this.handleChange({ target });
                    }}
                    allowLeadingZeros
                    value={this.state.basicInformation[prop.name]}
                    type='text'
                    placeholder={Strings(prop.name)}
                    allowNegative={false}
                    disabled={prop.disabled || this.props.disableTextField}
                    isAllowed={
                        prop.isAllowed
                            ? prop.isAllowed
                            : () => {
                                return true;
                            }
                    }
                    maxLength={prop.maxLength}
                />
            </div>
        );
    };
    renderMultiSelect = (prop) => {
        const matchedDropdown = this.props.dropdownValues?.find(item => item.nm === prop.key);
        const dropDownList = matchedDropdown?.opt || [];
        let errorClass = this.state.errorFieldArray?.includes(prop.name) ? true : false

        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <MultipleSelectCheckmarks
                    itemList={dropDownList}
                    placeHolder={Strings(prop.key)}
                    multiple={true}
                    selectedValues={this.state.basicInformation[prop.name] || []}
                    handleChange={this.handleChange}
                    name={prop.name}
                    NO_TAG_FIELDS={true}
                    disabled={this.props.disableTextField}
                />
            </div>
        )
    }


    isFieldRequired = (fieldKey) => {
        const { basicInformation } = this.state;

        if (ADMIN_FIELDS.includes(fieldKey)) {
            return basicInformation.holder?.toUpperCase() === "ADMIN";
        }
        return false;
    }

    isPersonalLoan = () => this.props.selectedLoanType === LOAN_TYPES.PERSONAL_LOAN;

    getFieldLabelKey = (field) => {
        if (this.isPersonalLoan()) {
            const override = PERSONAL_LOAN_FIELD_OVERRIDES[field.key];
            if (override?.labelKey) return override.labelKey;
        }
        return field.name;
    };

    isFieldHiddenForLoanType = (field) => {
        if (this.isPersonalLoan()) {
            return PERSONAL_LOAN_FIELD_OVERRIDES[field.key]?.hidden === true;
        }
        return false;
    };

    getFieldMandatory = (field) => {
        if (this.isPersonalLoan()) {
            const override = PERSONAL_LOAN_FIELD_OVERRIDES[field.key];
            if (override?.hidden) return false;
            if (override && 'isMandatory' in override) return override.isMandatory;
        }
        return field.isMandatory;
    };

    renderBasicInformationDetails = (editableData, section) => {
        const visibleFields = editableData.filter(prop => !this.isFieldHiddenForLoanType(prop));
        return (
            <Row className='subHeaderApplication addOrUpdateUserFontSize ps-3'>
                {visibleFields.map((prop) => {
                    const labelKey = this.getFieldLabelKey(prop);
                    const isMandatory = this.getFieldMandatory(prop);
                    let renderTextField;
                    if (prop.isDate) {
                        renderTextField = this.renderDate(prop, section);
                    } else if (prop.isSelection) {
                        renderTextField = this.renderSelectionDropDown(prop, section);
                    } else if (prop.type === "number") {
                        renderTextField = this.renderNumberTextFields(prop, section)
                    } else if (prop.isSelect === "multiSelect") {
                        renderTextField = this.renderMultiSelect(prop, section)
                    }
                    else {
                        let errorClass = this.state?.errorFieldArray?.includes(prop.name) ? " error-data" : ""
                        renderTextField = <div className={`textFieldComponent ${errorClass}`}>
                            <TextFieldComponent
                                id={prop.name}
                                type={prop.type}
                                className='noMargin'
                                placeholder={Strings(labelKey)}
                                value={this.state.basicInformation[prop.name] || ""} //NOSONAR
                                handleChange={this.handleChange}
                                name={prop.name}
                                disabled={prop.disabled || this.props.disableTextField}
                                maxLength={prop.maxLength}

                            />
                        </div>
                    }
                    return (
                        <Col
                            key={prop.name}
                            md={{ span: prop.md ? prop.md : 4 }}
                            className='ps-0 pe-3'
                        >
                            <Row>
                                <Col md={11}>
                                    <Row>
                                        <Col md={{ span: 12 }} className='px-0 pt-3'>
                                            <span className={prop.className ? prop.className : ""}>{Strings(labelKey)}</span>
                                            {(isMandatory || this.isFieldRequired(prop.key)) && (
                                                <span className='mandatoryFields'>*</span>
                                            )}
                                        </Col>
                                        <Col
                                            md={{ span: 12 }}
                                            className={
                                                prop.name === "aid" ? "px-0 pt-4 textFieldComponent fullWidth" : "px-0 pt-2 textFieldComponent fullWidth"
                                            }
                                        >
                                            {renderTextField}
                                        </Col>
                                    </Row>

                                </Col>

                            </Row>
                        </Col>
                    );
                })}
            </Row>
        );
    };

    renderConfirmationModal = () => {
        let modalText1 = this.state.modalMessage || "";
        let headerText = Strings("cedulaValidation");

        return (
            <UserModal
                open={this.state.showUserModal}
                modalCloseOnEsc={false}
                modalCloseOnOverlayClick={false}
                modalShowCloseIcon={false}
                headerText={headerText}
                modalText1={modalText1}
                modalButtonOk={{
                    text: Strings("Proceed"),
                    onClick: this.updateLoan,
                }}
                modalButtonCancel={{
                    text: Strings("Cancel"),
                    onClick: this.closeUserModal,
                }}
                showHr={true}
            />
        )
    }

    closeUserModal = () => {
        this.setState({
            showUserModal: false,
            modalMessage: ""
        });
    }

    updateLoan = () => {
        const { basicInformation } = this.state;

        const basicInfo = {
            ciCustomerSinceYears: basicInformation.ciCustomerSinceYears || "",
            businessEstablishedSinceYears: basicInformation.businessEstablishedSinceYears || "",
            telephone: basicInformation.ColmadoTelephone || "",
            ownerName: basicInformation.NameOfOwner || "",
            ownerId: basicInformation.IDOfOwner || "",
            ownerAddress: basicInformation.ownerAddress || "",
            ownerNumber: basicInformation.ownerNumber || "",
            adminName: basicInformation.adminName || null,
            adminId: basicInformation.adminId || null,
            adminNumber: basicInformation.adminNumber || null,
            holder: basicInformation.holder.toUpperCase() || "OWNER",
            ownerDateOfBirth: basicInformation.ownerDateOfBirth || null,
            adminDateOfBirth: basicInformation.adminDateOfBirth || null,
            ciCreditLimit: basicInformation.supplierCreditLimit || "",
            ownerHomeType: basicInformation.ownerHomeType || "",
            familyMembers: basicInformation.familyMembers || "",
            numberOfVehicles: basicInformation.numberOfVehicles || "",
            bankAccount: (basicInformation.bankDetail && basicInformation.bankDetail.length > 0) ? true : false,
            bankDetail: basicInformation.bankDetail && basicInformation.bankDetail.length > 0 ? basicInformation.bankDetail : null,
            receivesRemittances: (basicInformation.remittanceDetails && [basicInformation.remittanceDetails].length > 0) ? true : false,
            remittanceDetails: basicInformation.remittanceDetails ? basicInformation.remittanceDetails : null,
            socialMediaAccount: (basicInformation.socialMediaAccountDetails && basicInformation.socialMediaAccountDetails.length > 0) ? true : false,
            socialMediaAccountDetails: basicInformation.socialMediaAccountDetails && basicInformation.socialMediaAccountDetails.length > 0 ? basicInformation.socialMediaAccountDetails : null,
            homeLocation: basicInformation.homeLocation || "",
            adminSince: basicInformation.adminSince || null,
            adminAddress: basicInformation.adminAddress || null,
            adminSalary: basicInformation.adminSalary || null,
            businessType: basicInformation.businessType || ""
        };

        const requestData = {
            minimartId: this.props.minimartId,
            loanApplicationId: this.props.loanApplicationId,
            basicInfo: basicInfo
        };
        this.props.updateLoanApplcation(requestData, (errorMessage) => {
            this.setState({ errorMessage: errorMessage });
        });
    }

    cedulaValidate = () => {
        this.props.showLoadingModal();
        cedulaValidateAction({
            ownerId: this.state.basicInformation.IDOfOwner,
            loanApplicationId: this.props.loanApplicationId
        }, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.props.closeLoadingModal();
                if (response.data.data.is === false) {
                    let mod = response.data.data.mod;
                    let message = "";
                    if (mod && mod.length > 0) {
                        let existingMinimarts = this.getExistingRegisteredMinimarts(mod);
                        message = Strings("AlreadyCedulaRegistered").replace("*", existingMinimarts);
                    } else {
                        message = Strings("MismatchPastCedulaId");
                    }

                    this.setState({
                        showUserModal: true,
                        modalMessage: message
                    });
                } else {
                    this.updateLoan();
                }
            } else {
                this.props.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }
    getExistingRegisteredMinimarts = (mod) => {
        let existingMinimarts = "";
        mod.forEach((minimart, index) => {
            existingMinimarts = existingMinimarts + "" + minimart.mn + "(" + minimart.mid + ")";
            if (index !== mod.length - 1)
                existingMinimarts = existingMinimarts + ", "
        })
        return existingMinimarts;
    }

    validateData = () => {
        if (this.props.disableTextField) {
            this.props.goNext();
            return;
        }

        const { basicInformation } = this.state;
        const errors = [];
        const { businessInfo, ownerInfo, adminInfo } = loanApplicationFormInputs.basicInfo;
        const allFields = [...businessInfo, ...ownerInfo, ...adminInfo];
        let requiredFields = allFields.filter(field => {
            if (this.isFieldHiddenForLoanType(field)) return false;
            return this.getFieldMandatory(field);
        });

        if (basicInformation.holder && basicInformation.holder.toUpperCase() === "ADMIN") {
            ADMIN_FIELDS.forEach(fieldName => {
                const fieldConfig = allFields.find(field => field.name === fieldName);
                if (fieldConfig && !requiredFields.some(field => field.name === fieldName)) {
                    requiredFields.push(fieldConfig);
                }
            });
        }

        let errorMessage = "";
        const phoneFields = PHONE_FIELDS;
        const cedulaFields = CEDULA_FIELDS;

        requiredFields.forEach(({ key, name }) => {
            const value = basicInformation[name];
            if (
                phoneFields.includes(name) &&
                value &&
                value.length !== 10
            ) {
                errors.push(name);
                if (!errorMessage) {
                    errorMessage = Strings("telephoneNumberValidation");
                }
            }


            if (!value) {
                errors.push(name);
                if (!errorMessage) {
                    errorMessage = Strings("pleaseSelectRequiredFields");
                }
            }
        });

        // Cedula length is checked independently of the mandatory-field set: a non-empty cedula
        // must always be 11 digits, even for loan types / holder combinations where the field is
        // optional (e.g. PERSONAL_LOAN, where the owner cedula is shown as the customer ID).
        allFields.forEach((field) => {
            if (!cedulaFields.includes(field.name) || this.isFieldHiddenForLoanType(field)) {
                return;
            }
            const value = basicInformation[field.name];
            if (value && String(value).length !== 11 && !errors.includes(field.name)) {
                errors.push(field.name);
                if (!errorMessage) {
                    errorMessage = Strings("cedulaIdMustBeElevenDigits");
                }
            }
        });

        let finalErrorFieldArray = [...errors, ...this.state.invalidFormField];
        this.setState({
            errorFieldArray: finalErrorFieldArray,
            errorMessage: errorMessage,
        });

        if (finalErrorFieldArray.length === 0) {
            this.cedulaValidate();
        }
    };
    renderErrors = () => {
        return (
            <Row className="errors mb-0">
                <span>
                    {this.state.errorMessage}
                </span>
            </Row>
        )
    }
    renderButtons = () => {
        return (
            <Row className='modalButton justify-content-between ps-3'>
                <Col md={2} className='text-start'>
                    <Button
                        className='buttonBorder'
                        onClick={this.props.goBack}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>
                </Col>
                <Col md={4} className='d-flex justify-content-end pe-4'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goNext}
                        disabled={(!this.props.basicInfo?.prefillData) || this.props.showLoadingModalState}
                    >
                        {Strings("Next").toUpperCase()}
                    </Button>
                    {!this.props.disableTextField && <Button
                        className={
                            "buttonBackground"
                        }
                        onClick={this.validateData}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("saveAndProceed")}
                    </Button>}
                </Col>
            </Row>
        )
    }
    render() {
        const isPersonalLoan = this.isPersonalLoan();
        return (
            <Col md={12}>
                {this.state.errorMessage && this.renderErrors()}
                {this.renderBasicInformationDetails(loanApplicationFormInputs.basicInfo.businessInfo)}
                <Row className="ps-3 pt-2 pe-2">
                    <hr className="opacity-100 mb-2 mt-2" />
                </Row>
                <Row className="ps-3 pt-2 pe-2">
                    <span className="createLoanSubHeadingText">
                        {Strings(isPersonalLoan ? "CustomerInfo" : "Owner")}
                    </span>
                </Row>
                {this.renderBasicInformationDetails(loanApplicationFormInputs.basicInfo.ownerInfo)}
                <Row className="ps-3 pt-2 pe-2">
                    <hr className="opacity-100 mb-2 mt-2" />
                </Row>
                <Row className="ps-3 pt-2 pe-2">
                    <span className="createLoanSubHeadingText">
                        {Strings(isPersonalLoan ? "EmploymentInfo" : "ADMIN")}
                    </span>
                </Row>
                {this.renderBasicInformationDetails(loanApplicationFormInputs.basicInfo.adminInfo, "ADMIN")}
                <Row className="ps-3 pt-2 pe-2">
                    <hr className="opacity-100 mb-2 mt-2" />
                </Row>
                {this.state.showUserModal && this.renderConfirmationModal()}
                {this.renderButtons()}
            </Col>
        )
    }
}
export default BasicInformation;